type GetQueryParam = Record<string, string | null>;

export const getQueryParam = <K extends string[]>(search: string, keys: K) => {
	const params = new URLSearchParams(search);
	return keys.reduce((acc, item) => {
		acc = { ...acc, [item]: params.get(item) };
		return acc;
	}, {} as GetQueryParam);
};
